import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import withImmutablePropsToJS from "with-immutable-props-to-js"

// containers
import ResourceTableContainer from "app/static/frontend/sheets/containers/ResourceTableContainer"
import { ResourceTableWrapper } from "quorumdesign"

// selectors
import { searchTableConnection } from "app/static/frontend/search-new/containers/TableView/selectors"

// action creators
import { fetchSearchData, updateFilter } from "shared/search/action-creators"
import { getAlignmentTypes } from "shared/stakeholder/action-creators"

// constants
import { NO_RESULTS_EXPLANATION } from "app/static/frontend/search-new/containers/TableView/constants"

// helper functions
import { createOrderByFilterIdFromQDT } from "shared/search/containers/FilterGroup/FilterGroups.js"

export const SearchTableView = (props) => {
    // this is only used to fetch the count
    const fetchCount = (shouldLoadFromCache = true) =>
        props.fetchSearchData({
            uniqueFlvId: props.uniqueFlvId,
            resource: props.resource,
            countOnly: true,
            shouldLoadFromCache,
        })

    useEffect(() => {
        fetchCount()
    }, [JSON.stringify(props.rowFilter)])

    useEffect(() => {
        // only get alignment types when component first renders because they likely won't change
        getAlignmentTypes()
        // update filter based on quorum data type to remove ordering filter
        const uniqueFilterId = createOrderByFilterIdFromQDT(props.dataType)
        props.updateFilter(uniqueFilterId, props.uniqueFlvId, "", false)
    }, [])

    // Reduce the height of the listview for all the stuff that is above it
    const tableHeight = props.isProfile ? "calc(100vh - 266px)" : "calc(100vh - 264px)"

    return (
        <ResourceTableWrapper height={tableHeight}>
            <ResourceTableContainer
                // NOTE: Columns will ALSO include the datumColumn defined by QuorumDataType.display_key for the Data Type
                columns={props.columns}
                dataType={props.dataType}
                datumColumnSortingQuerymethod={props.datumColumnSortingQuerymethod}
                disableDatumFilter
                disableRowLink={props.disableRowLink}
                id={props.tableId}
                key={props.tableId}
                noResultsMessage={NO_RESULTS_EXPLANATION}
                resourceTableDatumTooltipText=""
                resourceTableShowLoadingSpinner={false}
                resourceTableTooltipText=""
                rowFilter={props.rowFilter}
                rowResource={props.resource}
                scrollInterval={props.scrollInterval}
                shouldShowLoadingSpinnerInitially
                shouldShowNoResultsWithoutFilters
            />
        </ResourceTableWrapper>
    )
}

SearchTableView.propTypes = {
    // from mapDispatchToProps
    fetchSearchData: PropTypes.func.isRequired,
    updateFilter: PropTypes.func.isRequired,

    // passed in FilterableListView component
    uniqueFlvId: PropTypes.string.isRequired,
    resource: PropTypes.object.isRequired,

    // from searchTableConnection
    columns: PropTypes.array.isRequired,
    dataType: PropTypes.number.isRequired,
    datumColumnSortingQuerymethod: PropTypes.string,
    disableRowLink: PropTypes.bool,
    rowFilter: PropTypes.object,
    scrollInterval: PropTypes.number.isRequired,
    tableId: PropTypes.string.isRequired,
}

export default connect(searchTableConnection, {
    fetchSearchData,
    updateFilter,
})(withImmutablePropsToJS(SearchTableView))
